import $ from "jquery";
import Splide from "@splidejs/splide";
import {start} from "@popperjs/core";

$(function () {
	let productionSlider = document.querySelectorAll(".aka-block-production-cards .splide");
	if (productionSlider.length > 0) {
		for (let i = 0; i < productionSlider.length; i++) {
			let cardsElement = productionSlider[i];
			let cardsDefaultOptions = {
				type: "loop",
				autoplay: 'play',
				autoWidth: true,
				lazyLoad: true,
				interval: 2200,
				start: 0,
				arrows: false,
				pagination: false,
				mediaQuery: "max",
				breakpoints: {
					767: {
						destroy: true,
					},
				},
			};

			let cards = new Splide(cardsElement, cardsDefaultOptions);
			cards.mount();
		}
	}
});
